<template>
    <div class="updatePsd">
        <div class="content">
          <h2>修改密码</h2>
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-form-item label="旧密码" prop="oldPwd">
              <el-input type="password" v-model="ruleForm.oldPwd" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="pass">
              <el-input type="password" v-model="ruleForm.pass" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
              <el-input type="password" v-model="ruleForm.checkPass" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item>
              <div style="margin: 20px 0px 0px 100px">
                <el-button type="primary" @click="submitForm('ruleForm')">修改密码</el-button>
                <el-button @click="resetForm('ruleForm')">重置</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
    </div>
</template>

<script>
    export default {
        name: "updatePsd",
      data(){
        var validatePass = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请输入密码'));
          } else {
            if (this.ruleForm.checkPass !== '') {
              this.$refs.ruleForm.validateField('checkPass');
            }
            callback();
          }
        };
        var validatePass2 = (rule, value, callback) => {
          var reg = /\D/;
          if (value === '') {
            callback(new Error('请再次输入密码'));
          } else if (value !== this.ruleForm.pass) {
            callback(new Error('两次输入密码不一致!'));
          } else if(!reg.test(value)){
            callback(new Error('密码由字符和数字组成!'));
          } else{
            callback()
          }
        };

        return{
          ruleForm:{
            pass:'',
            checkPass:'',
            oldPwd:''
          },
          rules: {
            oldPwd:[{required:true,message:'请输入旧密码',trigger:'blur'}],
            pass: [{validator:validatePass,trigger:'blur'}],
            checkPass: [
              {validator:validatePass2,trigger:'blur'},
              {min:8,message:'长度至少8个字符',blur}
            ],
          },
        }
      },
      methods:{
        submitForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              const userId= window.localStorage.getItem("UserId")
              this.Axios.put('/api/User/UpdateUserPwd/'+userId,{oldPwd:this.ruleForm.oldPwd.trim(),newPwd:this.ruleForm.pass.trim()}).then(res=>{
                if(res.data.status){
                  this.$message({
                    showClose: true,
                    message: res.data.message,
                    type: 'success'
                  });
                  window.localStorage.setItem("isFirst",'false')
                  this.$router.push({path:'index'})
                }else{
                  this.$message({
                    showClose: true,
                    message: res.data.message,
                    type: 'error'
                  });
                }
              }).catch(error=>{
                this.$message({
                  showClose: true,
                  message: '网络错误，联系管理员',
                  type: 'error'
                });
              })
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        resetForm(formName) {
          this.$refs[formName].resetFields();
        }
      },
      created(){
          // console.log("psd",this.$route.query.oldPwd)
        if(window.localStorage.getItem("isFirst")==='true'){
          this.$message({
            showClose: true,
            message: '强制修改密码！！',
            type: 'warning'
          });
        }
      }
    }
</script>

<style  lang="less">
  .updatePsd{
    width: 100%;
    height: 90vh;
    position: relative;
    background-color: white;
    .content{
      width: 600px;
      height: 400px;
      position: absolute;
      top:0;
      left:0;
      right: 0;
      bottom:0;
      margin: auto;
      border: 1px solid #999999;
      border-radius: 5px;
      h2{
        padding: 40px;
        text-align: center;
      }
      .el-input{
        width: 85%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/login/updatePsd.vue